import {
  Button,
  Modal,
  ModalContent,
  ModalTrigger,
  Icon,
} from '@repo/ui/components'
import { useTranslate } from '@repo/shared/hooks'
import { useUserAuthDetails } from '@repo/services'

import { KycBlocker } from '@repo/shared/components'
import { CardInput } from '@repo/profile/containers'

export const WithdrawOnlinePaymentAddCard = () => {
  const { t } = useTranslate()
  const { data: authDetails } = useUserAuthDetails()
  const hasKyc =
    authDetails?.data.details?.kyc &&
    authDetails?.data.details?.kyc?.status === 'approved'

  return (
    <Modal>
      <ModalTrigger asChild>
        <Button
          type='button'
          color='base'
          variant='transparent'
          size='sm'
          startIcon={<Icon name='PlusLine' size='sm' />}
        >
          {t('withdrawOnlinePaymentPage_add_card')}
        </Button>
      </ModalTrigger>
      <ModalContent className='sm:max-w-[425px]'>
        {hasKyc ? (
          <CardInput />
        ) : (
          <KycBlocker
            phone={authDetails?.data.phone}
            email={authDetails?.data.email}
            kyc={authDetails?.data.details?.kyc}
          />
        )}
      </ModalContent>
    </Modal>
  )
}
